import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import {
    SpacingToken,
    UiStack,
} from '@experiences/ui-common';
import { Box } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import {
    WizardStepContainer,
    WizardStepHeader,
} from '../WizardStepLayout';
import useGovernancePolicyCreateReviewAndSaveStepViewModel from './GovernancePolicyCreateReviewAndSaveStepViewModel';
import { GovernancePolicyPreview } from './GovernancePolicyPreview';

interface GovernancePolicyCreateReviewAndSaveStepProps {
    type?: 'add' | 'edit';
    mode?: 'create' | 'edit';
}

export const GovernancePolicyCreateReviewAndSaveStep: React.FC<GovernancePolicyCreateReviewAndSaveStepProps> = ({
    type = 'add', mode = 'create',
}) => {
    const { formatMessage: translate } = useIntl();
    const EnableGovernanceAccessDecisionEdit = useFeatureFlagValue(Features.EnableGovernanceAccessDecisionEdit.name);

    const {
        handleEditPolicyDefinition,
        handleEditNameAndDescription,
        handleEditEnforcement,
    } = useGovernancePolicyCreateReviewAndSaveStepViewModel({
        type,
        mode,
    });

    return (
        <WizardStepContainer
            type={type}
            data-cy="governance-policy-create-review-and-save-step">
            <UiStack
                direction="column"
                h="inherit"
            >
                <WizardStepHeader
                    title={translate({ id: 'CLIENT_GOVERNANCE_STEP_REVIEW_AND_SAVE_TITLE' })}
                    description={translate({ id: 'CLIENT_GOVERNANCE_STEP_REVIEW_AND_SAVE_DESCRIPTION' })}
                />

                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflow: 'auto',
                        mt: SpacingToken.M,
                    }}
                    data-cy="governance-policy-review-panel-container"
                >
                    <GovernancePolicyPreview
                        onEditResources={handleEditPolicyDefinition}
                        onEditAutomations={handleEditPolicyDefinition}
                        onEditDecision={EnableGovernanceAccessDecisionEdit ? handleEditPolicyDefinition : undefined}
                        onEditNameAndDescription={handleEditNameAndDescription}
                        onEditEnforcement={handleEditEnforcement}
                        mode={mode}
                    />
                </Box>
            </UiStack>
        </WizardStepContainer>
    );
};
